module.exports = __webpack_public_path__ + "img/kelebihan-5.c811e941.jpg";